module.exports = __webpack_public_path__ + "img/nurse.719a98b5.png";